export var PageCategory;
(function (PageCategory) {
    PageCategory["BrandImage"] = "brand_image";
    PageCategory["CareersApplications"] = "careers_applications";
    PageCategory["FavoritesWishlist"] = "favorites_wishlist";
    PageCategory["Form"] = "form";
    PageCategory["HelpSupport"] = "help_support";
    PageCategory["PressNews"] = "press_news";
    PageCategory["AppointmentsBooking"] = "appointments_booking";
    PageCategory["OffersServices"] = "offers_services";
    PageCategory["FormationsServices"] = "formations_services";
    PageCategory["Home"] = "home";
    PageCategory["Category"] = "category";
    PageCategory["Product"] = "product";
    PageCategory["Cart"] = "cart";
    PageCategory["AccountCreation"] = "account_creation";
    PageCategory["CheckoutLeadGeneration"] = "checkout_lead_generation";
    PageCategory["Checkout"] = "checkout";
    PageCategory["Confirmation"] = "confirmation";
    PageCategory["Information"] = "information";
    PageCategory["InformationLegals"] = "information_legals";
    PageCategory["MyAccount"] = "my_account";
    PageCategory["Universe"] = "universe";
    PageCategory["Other"] = "other";
    PageCategory["Search"] = "search";
    PageCategory["StoreLocator"] = "store_locator";
    PageCategory["Content"] = "content";
    PageCategory["Configurator"] = "configurator";
    PageCategory["VideoPlayer"] = "video_player";
    PageCategory["Customers"] = "customers";
    PageCategory["EventsWebinars"] = "events_webinars";
})(PageCategory || (PageCategory = {}));
export var CategoryVersion;
(function (CategoryVersion) {
    CategoryVersion["V1"] = "v1";
    CategoryVersion["V2"] = "v2";
    CategoryVersion["Common"] = "common";
})(CategoryVersion || (CategoryVersion = {}));
//# sourceMappingURL=page-category.enum.js.map